<template>
  <div class="app-wrapper">
    <header-view />
    <router-view></router-view>
    <footer-view />
  </div>
</template>

<script>
import footerView from './footer'
import headerView from './header'
export default {
  name: 'Layout',
  components: {
    headerView,
    footerView
  }
}
</script>

<style scoped>
.app-wrapper {
  padding-top: 84px;
  background: #fff;
  min-height: 100vh;
}

@media (max-width: 1024px) {
  .app-wrapper {
    padding-top: 64px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue